import { setObjectToIndexedDB, Stores, getObjectFromIndexedDB } from '@/utils/indexedDB/indexed.db'
import { DefaultCanvasBlocks, _migrateDefaultBlockIds } from '@/utils/CanvasBlocksLayout'

export default {
  // NOTES: This file's used for Content slides + import PDF/PPT
  async loadContentSlidesCanvasBlocks(editor, res, { cachedContentSlides = true }) {
    const contentSlides = res.body.slides.filter((item) => {
      return item && item.type === 'freestyle'
    })
    const getContentPromises = this._getContentCanvasBlocks(editor,
      contentSlides, cachedContentSlides)

    await Promise.all(getContentPromises).then((data) => {
      this.updateCanvasBlocksArrayToAllSlidesInPresentation(data, editor)
    })

    await this.updateCanvasBlockForSlideActive(editor, contentSlides,
      { cachedContentSlides })
  },

  _getContentCanvasBlocks(editor, contentSlides, cachedContentSlides) {
    return contentSlides.map(async (s) => {
      const cachedData = await getObjectFromIndexedDB(s.id, Stores.contentSlideCanvasBlocksStore)
      if (cachedContentSlides && cachedData && cachedData.canvasBlocks) {
        return {
          id: s.id,
          canvasBlocks: cachedData.canvasBlocks,
        }
      }

      if (s.canvasBlocksUrl) {
        try {
          const response = await editor.$http.get(s.canvasBlocksUrl)
          let canvasBlocks = response.body ? response.body : DefaultCanvasBlocks(s.id)
          canvasBlocks = _migrateDefaultBlockIds(canvasBlocks, s.id)

          setObjectToIndexedDB(s.id, Stores.contentSlideCanvasBlocksStore, {
            canvasBlocks,
          })
          return {
            id: s.id,
            canvasBlocks,
          }
        } catch (error) {
          //
        }
      }

      let canvasBlocks = DefaultCanvasBlocks(s.id)
      canvasBlocks = _migrateDefaultBlockIds(canvasBlocks, s.id)
      return {
        id: s.id,
        canvasBlocks,
      }
    })
  },

  updateCanvasBlocksArrayToAllSlidesInPresentation(data, editor) {
    // Update canvasBlocksArray to all slides data in the presentation
    editor.$store.state.presentation.slides = editor.$store.state.presentation.slides.map((s) => {
      if (s.type !== 'freestyle') return s
      const slideIndex = data.findIndex((t) => t.id === s.id)
      const dataCanvasBlocks = data[slideIndex] ? data[slideIndex].canvasBlocks : null

      return {
        ...s,
        canvasBlocks: dataCanvasBlocks,
      }
    })
  },

  async updateCanvasBlockForSlideActive(editor, contentSlides, { cachedContentSlides }) {
    const contentSlideActiveIndex =
      contentSlides.findIndex((item) => item.id === editor.slideActive.id)
    if (contentSlideActiveIndex > -1) {
      try {
        const cachedData = await getObjectFromIndexedDB(
          editor.slideActive.id,
          Stores.contentSlideCanvasBlocksStore,
        )
        if (cachedContentSlides && cachedData && cachedData.canvasBlocks) {
          editor.$store.dispatch('updateSlideActive', {
            canvasBlocks: cachedData.canvasBlocks,
          })
        } else {
          const resGetContentSlideActive =
            await editor.$http.get(contentSlides[contentSlideActiveIndex].canvasBlocksUrl)
          let dataCanvasBlocks = resGetContentSlideActive.body ?
            resGetContentSlideActive.body :
            DefaultCanvasBlocks(editor.slideActive.id)
          dataCanvasBlocks = _migrateDefaultBlockIds(dataCanvasBlocks, editor.slideActive.id)

          editor.$store.dispatch('updateSlideActive', {
            canvasBlocks: dataCanvasBlocks,
          })
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
}
